<ng-container *ngIf="financialData">
  <div class="container-fluid mt-5" *ngIf="financialData.length > 0; else noReport">
    <div class="mb-3">
      <h5 class="mb-2">Type de coût</h5>
      <div class="row col-12 mb-4">
        <mat-slide-toggle #financialType *ngFor="let type of availableFinancialTypes" [id]="type" class="col-sm-2 mt-1"
          color="accent" [checked]="selectedFinancialTypes.includes(type)" (change)="financialTypesChanged($event)">{{
          trackingHelper.getFinancialTypeName(type) }}</mat-slide-toggle>
      </div>
    </div>
    <div>
      <!--  CHART -->
      <google-chart class="noverflow w-100" #chart [type]="chartType" [dynamicResize]="true" [data]="chartData"
        [options]="options" [columns]="columns"></google-chart>
    </div>
  </div>
  <ng-template #noReport>
    <div class="container-fluid text-center mt-5">
      <p class="mt-5 text-white">
        Aucune donnée financière n'est disponible. <br />
        Renseignez les coûts de vos consommations, travaux, entretiens ou charges pour les
        visualiser !
      </p>
    </div>
  </ng-template>
</ng-container>
